export enum EmailModel {    
    Donor = 1,
    DcnDonor = 9,
    OneWay = 2,
    Rccap = 3,
    Recipient = 4,
    Rexm = 5,
    SwapPosition = 6,
    XmTracking = 7,
    SerologyTracking = 8,
    SwapDonorPosition = 10
}